import React, { useState } from 'react';
import { FileTextIcon, UsersIcon, DollarSignIcon, TruckIcon, FileCheckIcon } from 'lucide-react';
import { QuoteStepHeader } from '../shared/QuoteStepHeader';
import { QuoteStepNavigation } from '../shared/QuoteStepNavigation';
import { ProjectDetailsStep } from './ProjectDetailsStep';
import { CustomerInfoStep } from '../shared/CustomerInfoStep';
import { ProjectItemsStep } from './ProjectItemsStep';
import { ShippingTermsStep } from '../shared/ShippingTermsStep';
import { QuoteReviewStep } from '../shared/QuoteReviewStep';
export function ProjectQuoteFlow({
  initialData = null
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [quoteData, setQuoteData] = useState({
    projectDetails: initialData?.projectDetails || {},
    customerInfo: initialData?.customerInfo || {},
    items: initialData?.items || [],
    shipping: initialData?.shipping || {},
    // Preservar otros datos importantes si estamos editando
    ...(initialData && {
      id: initialData.id,
      quoteNumber: initialData.quoteNumber,
      date: initialData.date,
      status: initialData.status,
      expiryDate: initialData.expiryDate,
      quotedBy: initialData.quotedBy,
      type: 'Project'
    })
  });
  const steps = [{
    label: 'Project Details',
    icon: <FileTextIcon size={16} data-id="element-4522" />
  }, {
    label: 'Customer Info',
    icon: <UsersIcon size={16} data-id="element-4523" />
  }, {
    label: 'Project Items',
    icon: <DollarSignIcon size={16} data-id="element-4524" />
  }, {
    label: 'Shipping & Terms',
    icon: <TruckIcon size={16} data-id="element-4525" />
  }, {
    label: 'Review',
    icon: <FileCheckIcon size={16} data-id="element-4526" />
  }];
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      // Submit quote
      console.log('Submit quote', quoteData);
    }
  };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleSave = () => {
    console.log('Save draft', quoteData);
  };
  const updateQuoteData = (section, data) => {
    setQuoteData({
      ...quoteData,
      [section]: data
    });
  };
  return <div className="bg-slate-800/30 rounded-xl border border-blue-800/30 p-6" data-id="element-4527">
      <QuoteStepHeader steps={steps} currentStep={currentStep} onChangeStep={setCurrentStep} data-id="element-4528" />
      <div className="mt-8" data-id="element-4529">
        {currentStep === 0 && <ProjectDetailsStep initialData={quoteData.projectDetails} onUpdate={data => updateQuoteData('projectDetails', data)} data-id="element-4530" />}
        {currentStep === 1 && <CustomerInfoStep initialData={quoteData.customerInfo} onUpdate={data => updateQuoteData('customerInfo', data)} data-id="element-4531" />}
        {currentStep === 2 && <ProjectItemsStep initialData={quoteData.items} onUpdate={data => updateQuoteData('items', data)} data-id="element-4532" />}
        {currentStep === 3 && <ShippingTermsStep initialData={quoteData.shipping} onUpdate={data => updateQuoteData('shipping', data)} data-id="element-4533" />}
        {currentStep === 4 && <QuoteReviewStep quoteData={quoteData} quoteType="Project" data-id="element-4534" />}
      </div>
      <QuoteStepNavigation currentStep={currentStep} totalSteps={steps.length} onNext={handleNext} onBack={handleBack} onSave={handleSave} isFinalStep={currentStep === steps.length - 1} data-id="element-4535" />
    </div>;
}